/*
 * Author: Blue Lobster Private Limited
 * Copyright: Blue Lobster Private Limited
 */
import { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import ThemeProvider from "@/layout/provider/Theme";
import { lazyWithRetry } from "@/utils/lazyWithRetry";

const Layout = lazyWithRetry(() => import("@/layout/Index"));
const LayoutNoSidebar = lazyWithRetry(() => import("@/layout/Index-nosidebar"));
const PawnApp = lazyWithRetry(() => import("@/pawn/PawnApp"));
const CbsActionPage = lazyWithRetry(() => import("@/pages/cbs/CbsActionPage"));
const CbsDashboard = lazyWithRetry(() => import("@/pages/cbs/CbsDashboard"));
const CbsModulePage = lazyWithRetry(() => import("@/pages/cbs/CbsModulePage"));
const CbsRecordPage = lazyWithRetry(() => import("@/pages/cbs/CbsRecordPage"));
const CbsRegisterPage = lazyWithRetry(
	() => import("@/pages/cbs/CbsRegisterPage"),
);
const Error404 = lazyWithRetry(() => import("@/pages/error/404-modern"));

const Router = () => (
	<BrowserRouter>
		<Suspense fallback={<div style={{ padding: 24 }}>Loading…</div>}>
			<Routes>
				<Route element={<ThemeProvider />}>
					<Route element={<Layout />}>
						<Route index element={<CbsDashboard />} />
						<Route path="cbs/gold-loans/*" element={<PawnApp />} />
						<Route path="cbs/:moduleId" element={<CbsModulePage />} />
						<Route
							path="cbs/:moduleId/action/:actionId"
							element={<CbsActionPage />}
						/>
						<Route
							path="cbs/:moduleId/register"
							element={<CbsRegisterPage />}
						/>
						<Route
							path="cbs/:moduleId/records/:recordIndex"
							element={<CbsRecordPage />}
						/>
					</Route>
					<Route element={<LayoutNoSidebar />}>
						<Route path="*" element={<Error404 />} />
					</Route>
				</Route>
			</Routes>
		</Suspense>
		<Toaster
			position="top-right"
			duration={3000}
			closeButton
			richColors
			visibleToasts={9}
			gap={12}
		/>
	</BrowserRouter>
);

export default Router;
